// React
import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useRoutes, useSearchParams } from 'react-router-dom';

// Components
import LeadDetailsComponent from './details/LeadDetails.component';
import LeadListComponent from './list/LeadsList.component';

// Config
import { routesConfig } from '../routes/routes.config';
import { defaultTab } from '../../components/lead/list/filter/LeadsTabQuickFilter.component';
import { LeadsCallQueryParamsType, LeadTabId } from '../../types/LeadsList';
import { WorkflowStatesContext } from '../../model/context/app/workflowStates';

/**
 * Entry point for leads backoffice ui app.
 * At the initial load of this component a standard fetch is started by defining the init value of `fetchParams`.
 *
 * @returns React.ReactElement
 */
export default function LeadComponent(): React.ReactElement {
    const workflowStates = useContext(WorkflowStatesContext);
    const [searchParams] = useSearchParams();
    const [fetchParams, setFetchParams] = useState<LeadsCallQueryParamsType>({
        page: 0,
        size: 24,
    });
    const [activeTab, setActiveTab] = useState<LeadTabId>(defaultTab);

    useEffect(() => {
        setFetchParams((oldParams) => {
            return {
                ...oldParams,
                status: workflowStates.states[(searchParams.get('listView') as LeadTabId) ?? defaultTab].map(
                    (st: string) => st
                ),
            };
        });
    }, [workflowStates, setFetchParams]);

    const routes = useRoutes([
        {
            path: routesConfig.list,
            element: (
                <LeadListComponent
                    fetchParams={fetchParams}
                    setFetchParams={setFetchParams}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            ),
        },
        {
            path: routesConfig.detail,
            element: <LeadDetailsComponent data-testid="leadDetails" />,
        },
    ]);

    return (
        <>
            {routes}
            <Outlet />
        </>
    );
}
